import { Map } from "mapbox-gl";
import { connect } from "react-redux";
import { ApplicationState } from "../reducers";
import { CalculatedTiming } from "../model/timing";
import { MapViewType } from "./MapViewType";
import { GunshotObservation } from "../model/rounds";

export interface MapboxProps {
  timing?: CalculatedTiming;
  round?: GunshotObservation;
}

export interface OwnProps {
  map: Map;
  loaded: boolean;
  mapType?: MapViewType;
}

export interface Props extends OwnProps, MapboxProps {}

function addTimingLayer(map: Map) {
  map.addLayer({
    id: "timing-lines",
    paint: {
      "line-color": ["get", "color"],
      "line-width": ["get", "width"]
    },
    source: "timing-lines",
    type: "line"
  });
}

function addTimingSource(map: Map, timing?: CalculatedTiming, round?: GunshotObservation) {
  map.addSource("timing-lines", {
    data: timingLines(timing, round),
    type: "geojson"
  });
}

export const timingLines = (
  timing?: CalculatedTiming,
  round?: GunshotObservation
): GeoJSON.FeatureCollection => {
  return {
    features: createFeatures(timing, round),
    type: "FeatureCollection"
  };
};

const createFeatures = (timing?: CalculatedTiming, round?:GunshotObservation): any => {
  const features = [];
  if (timing && round?.target) {
    // @ts-ignore
    features.push({
      geometry: {
        coordinates: [
          [round.device.position.master.lon, round.device.position.master.lat],
          [round.target.position.lon, round.target.position.lat]
        ],
        type: "LineString"
      },
      id: `gunshot2impact`,
      properties: {
        id: `gunshot2impact`,
        color: `yellow`,
        width: 3
      },
      type: "Feature"
    });
    // @ts-ignore
    features.push({
      geometry: {
        coordinates: [
          [round.device.position.master.lon, round.device.position.master.lat],
          [round.device.position.lon, round.device.position.lat],
        ],
        type: "LineString"
      },
      id: `gunshot2device`,
      properties: {
        id: `gunshot2device`,
        color: `green`,
        width: 3
      },
      type: "Feature"
    });
    
    [timing.minSonicBoom, timing.maxSonicBoom].forEach((sonicBoom, i) => {
      if (sonicBoom.shockWaveTrajectory) {
        // @ts-ignore
        features.push({
          geometry: {
            coordinates: [
              [
                sonicBoom.shockWaveTrajectory.origin.longitude,
                sonicBoom.shockWaveTrajectory.origin.latitude
              ],
              [sonicBoom.shockWaveTrajectory.end.longitude, sonicBoom.shockWaveTrajectory.end.latitude]
            ],
            type: "LineString"
          },
          id: `gunshot2device_${i}`,
          properties: {
            id: `gunshot2device`,
            color: `blue`,
            width: 3
          },
          type: "Feature"
        });
      }
    })
   
  }
  return features;
};

function updateTimingSource(map: Map, timing?: CalculatedTiming, round?: GunshotObservation) {
  map
    .getSource("timing-lines")
    // @ts-ignore
    .setData(timingLines(timing, round));
}

const TimingLinesLayer = ({ map, loaded, timing, round }: Props) => {
  if (map && loaded) {
    if (!map.getSource("timing-lines")) {
      addTimingSource(map, timing, round);
      addTimingLayer(map);
    } else {
      updateTimingSource(map, timing, round);
    }
  }

  return null;
};

const mapStateToProps = (state: ApplicationState) => {
  const selectedRound = state.round.selectedRound;
  const observation =
    selectedRound &&
    selectedRound.observations.find(
      o => o.device.name === state.round.selectedDevice
    );

  return {
    timing: observation ? observation.calculatedTiming : undefined,
    round: observation
  };
};

// @ts-ignore
export default connect<MapboxProps, {}, {}>(mapStateToProps)(TimingLinesLayer);
